const DriveComp2 = () => {
    return (
        <p className="driveText2">
            <div className="secText2">
                <p className="pExplore2">Meet the host</p>
            </div>  </p>

    )
}
export default DriveComp2;